import React from "react";
import { string, number, func } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import GoogleAuth from "../../atoms/google-auth";
import FacebookAuth from "../../atoms/facebook-auth";

import { setMember, setLoading } from "../../helper/actions";

import "./login-view.m.css";

const LoginView = ({
  navigateToPage,
  closePopup,
  googleClientId,
  facebookId,
  setMember,
  setLoading,
  setUpUserFlow,
}) => {
  const subscribeClick = () => {
    closePopup();
    navigateToPage("/plan-selection");
  };

  return (
    <div styleName="wrapper">
      <span styleName="login-title">Welcome Back.</span>
      <span styleName="description">
        Log in to get the complete ad free experience and personalized story recommendations
      </span>

      <GoogleAuth
        text="Continue with Google"
        googleClientId={googleClientId}
        setMember={setMember}
        setLoading={setLoading}
        closePopup={closePopup}
        setUpUserFlow={setUpUserFlow}
      />

      <div styleName="facebook-auth">
        <FacebookAuth
          text="Continue with Facebook"
          facebookId={facebookId}
          setMember={setMember}
          setLoading={setLoading}
          closePopup={closePopup}
          setUpUserFlow={setUpUserFlow}
        />
      </div>

      <div styleName="account">
        <span>Don&apos;t have an account?</span>
        <span styleName="subscribe" onClick={subscribeClick}>
          Subscribe Now!
        </span>
      </div>
    </div>
  );
};

LoginView.propTypes = {
  navigateToPage: func,
  closePopup: func,
  googleClientId: string,
  facebookId: number,
  setMember: func,
  setLoading: func,
  setUpUserFlow: func,
};

const mapStateToProps = (state) => ({
  googleClientId: get(state, ["qt", "config", "publisher-attributes", "socialAuth", "google"], ""),
  facebookId: get(state, ["qt", "config", "publisher-attributes", "socialAuth", "fb"], ""),
});

const mapDispatchToProps = (dispatch) => ({
  navigateToPage: (url) => global.app.navigateToPage(dispatch, url),
  setMember: (member) => dispatch(setMember(member)),
  setLoading: (isLoading) => dispatch(setLoading(isLoading)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginView);
